import { Guid } from "../../../types/guid.type";
import { EntityBase, IEntityBaseInfo } from "../../entity/entitybase";

export interface IEquipmentAssignmentTicketInfo extends IEntityBaseInfo {
  EquipmentAssignmentUid?: Guid;
  VehicleAssignmentUid?: Guid;
  TicketUid?: Guid;
  AuthorUid?: Guid;
}

export class EquipmentAssignmentTicket extends EntityBase {
  EquipmentAssignmentUid?: Guid;
  VehicleAssignmentUid?: Guid;
  TicketUid?: Guid;
  AuthorUid?: Guid;

  constructor(info: IEquipmentAssignmentTicketInfo) {
    super(info);
    this.EquipmentAssignmentUid = info.EquipmentAssignmentUid ?? info.VehicleAssignmentUid;
    this.VehicleAssignmentUid = this.EquipmentAssignmentUid;
    this.TicketUid = info.TicketUid;
    this.AuthorUid = info.AuthorUid;
  }
}
